import { buildEndpointUrls } from "./apiUrls";

export const portalApiUrl = (path) => buildEndpointUrls(process.env.REACT_APP_API_BASE || "", `/api/client-portal${path}`, `/client-portal${path}`)[0];

export async function portalRequest(path, { staff = false, ...options } = {}) {
  let token = "";
  if (staff) {
    for (const storage of [localStorage, sessionStorage]) {
      for (const key of ["token", "authToken", "jwt", "accessToken", "access_token"]) {
        token = token || storage.getItem(key) || "";
      }
    }
  }
  const response = await fetch(portalApiUrl(path), {
    ...options, credentials: "include",
    headers: { "Content-Type": "application/json", "X-Requested-With": "rpo-client-portal", ...(token ? { Authorization: `Bearer ${token.replace(/^Bearer\s+/i, "")}` } : {}), ...options.headers },
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw Object.assign(new Error(data.error || "Could not load the Client Portal."), { status: response.status });
  return data;
}

export const safePortalLink = (value) => {
  try { const url = new URL(value); return ["https:", "http:"].includes(url.protocol) ? url.href : ""; } catch { return ""; }
};
